<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">
            {{ CompartTypeName}}
        </span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
    </div>
<div class="table-responsive mt-3">
    <table class="table table--full-width table--striped">
      <thead>
        <tr>
          <th>Component</th>
          <th>SMU</th>
          <th>Hours On Surface</th>
          <th>Wear %</th>
          <th>Budget Life</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let row of tableData">
          <td>{{ row.Compart }}</td>
          <td>{{ row.SMU }}</td>
          <td>{{ row.HoursOnSurface }}</td>
          <td>{{ row.WornPercentage }}</td>
          <td>{{ row.ComponentBudgetLife }}</td>
        </tr>
      </tbody>
    </table>
    </div>
    
</div>